import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress } from "@mui/material";

const Success = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const fakeLoading = setInterval(() => {
      setProgress((prev) => (prev >= 99 ? 98 : prev + Math.random() * 3));
      console.log(`[INFO] Processing request ${Math.floor(Math.random() * 10000)}`);
    }, 1000);

    const fakeAPICall = setInterval(() => {
      fetch("https://nonexistent.api.com/validate")
        .then(() => console.log("[DEBUG] Validation request sent"))
        .catch(() => console.warn("[WARN] API validation timed out, retrying..."));
    }, 5000);

    return () => {
      clearInterval(fakeLoading);
      clearInterval(fakeAPICall);
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <CircularProgress size={48} thickness={3} sx={{ color: '#2383e2', mb: 3 }} />
      <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.secondary' }}>
        Processing request... {Math.floor(progress)}%
      </Typography>
    </Box>
  );
};

export default Success;
